import React from "react";
import "./ShotMapWithFilters.css";

const renderMarkerSvg = (shape, stroke) => {
  const common = { fill: "none", stroke, strokeWidth: 1.2 };
  if (shape === "circle") {
    return (
      <svg width="18" height="18" viewBox="0 0 14 14">
        <circle cx="7" cy="7" r="3.5" {...common} />
      </svg>
    );
  }
  if (shape === "square") {
    return (
      <svg width="18" height="18" viewBox="0 0 14 14">
        <rect x="3.5" y="3.5" width="7" height="7" {...common} />
      </svg>
    );
  }
  if (shape === "diamond") {
    return (
      <svg width="18" height="18" viewBox="0 0 14 14">
        <polygon points="7,1 13,7 7,13 1,7" {...common} />
      </svg>
    );
  }
  return (
    <svg width="18" height="18" viewBox="0 0 14 14">
      <polygon points="7,1.5 12.5,12 1.5,12" {...common} />
    </svg>
  );
};

export default function ShotMapLegend() {
  const setPlayStroke = "#F8F9FA";

  return (
    <div className="legend">
      <h6>Shot Outcomes</h6>
      <div className="legend-item">
        <span className="legend-icon">{renderMarkerSvg("circle", "#FFFFFF")}</span>
        Point
      </div>
      <div className="legend-item">
        <span className="legend-icon">{renderMarkerSvg("circle", "#1f77b4")}</span>
        2-Point
      </div>
      <div className="legend-item">
        <span className="legend-icon">{renderMarkerSvg("circle", "#006400")}</span>
        Goal
      </div>
      <div className="legend-item">
        <span className="legend-icon">{renderMarkerSvg("circle", "#FF0000")}</span>
        Miss
      </div>

      <h6 className="mt-3">Set Play</h6>
      <div className="legend-item">
        <span className="legend-icon">{renderMarkerSvg("circle", setPlayStroke)}</span>
        Point - Open Play
      </div>
      <div className="legend-item">
        <span className="legend-icon">{renderMarkerSvg("square", setPlayStroke)}</span>
        Point - Dead Ball
      </div>
      <div className="legend-item">
        <span className="legend-icon">{renderMarkerSvg("diamond", setPlayStroke)}</span>
        2-Point
      </div>
      <div className="legend-item">
        <span className="legend-icon">{renderMarkerSvg("triangle", setPlayStroke)}</span>
        Goal
      </div>
    </div>
  );
}
